/*global themeVars */
const instanceVars = themeVars;
const { ajaxUrl, security } = instanceVars

/**
 * Download guide pdf
 */
export const downloadGuidePdf = () => {

	document.querySelectorAll( '.smoobu-download-file-form-pdf' ).forEach( ( container ) => {

		container.addEventListener( 'click', ( e ) => {

			if ( e.target.classList.contains( 'b-download-guide-button-form' ) ) {

				e.preventDefault();
				const button = e.target;

				const dataTitle = document.querySelector( '.b-guide-post-title__title' )?.textContent;
				const postId = getPostIdFromBodyClass();

				if ( postId && dataTitle ) {

					const originalText = button.textContent;
					button.textContent = `${originalText}...`;
					button.disabled = true;

					const fileName = sanitizeTitle( dataTitle );

					fetch( ajaxUrl, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded',
						},
						body: new URLSearchParams( {
							action: 'guide_generate_pdf',
							postId: postId,
							nonce: security,
						} ),
					} )
						.then( response => {

							if ( !response.ok ) {

								throw new Error( 'PDF generate Failed.' );

							}
							return response.blob();

						} )
						.then( blob => {

							const url = window.URL.createObjectURL( blob );
							const a = document.createElement( 'a' );
							a.href = url;
							a.download = `${fileName}.pdf`;
							document.body.appendChild( a );
							a.click();
							a.remove();
							window.URL.revokeObjectURL( url );

						} )
						.finally( () => {

							button.textContent = originalText;
							button.disabled = false;

						} );

				}

			}

		} );

	} )

	/**
	 * Sanitize title string
	 * @param {string} str
	 * @return {string}
	 */
	function sanitizeTitle( str ) {

		return str
			.normalize( 'NFD' )
			.replace( /[\u0300-\u036f]/g, '' )
			.replace( /[^a-zA-Z0-9\s-]/g, '' )
			.trim()
			.toLowerCase()
			.replace( /\s+/g, '-' )
			.replace( /-+/g, '-' );

	}

	/**
	 * Retrieves the post ID from the <body> element's class list.
	 *
	 * @return {string|null} The post ID as a string if found, otherwise null.
	 */
	function getPostIdFromBodyClass() {

		const bodyClasses = document.body.className.split( /\s+/ );
		for ( const cls of bodyClasses ) {

			if ( cls.startsWith( 'postid-' ) ) {

				return cls.replace( 'postid-', '' );

			}

		}
		return null;

	}

};
